export const event = {
  TIMKH: [
    {
      id: "e1",
      name: "TIMKH",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672783019/timkh/FB_IMG_1672731173530_bcukoy.jpg",
    },
    {
      id: "e2",
      name: "TIMKH",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672783018/timkh/FB_IMG_1672731153226_glqqcb.jpg",
    },
    {
      id: "e11",
      name: "TIMKH",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672783017/timkh/FB_IMG_1672731094835_mmerl9.jpg",
    },
    {
      id: "e12",
      name: "TIMKH",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672783019/timkh/FB_IMG_1672731185287_v6hhx6.jpg",
    },
    {
      id: "e13",
      name: "TIMKH",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672783014/timkh/FB_IMG_1672731180666_jggqng.jpg",
    },
    {
      id: "e14",
      name: "TIMKH",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672783003/timkh/FB_IMG_1672731009075_tcyqds.jpg",
    },

  ],
  KABOD: [
    {
      id: "eS3",
      name: "KABOD",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782837/kabod/FB_IMG_1672677217840_g4ttvd.jpg",
    },
    {
      id: "eS4",
      name: "KABOD",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782836/kabod/FB_IMG_1672676987468_ojh7et.jpg",
    },
    {
      id: "eS5",
      name: "KABOD",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782831/kabod/FB_IMG_1672676875075_goluzr.jpg",
    },
    {
      id: "eS6",
      name: "KABOD",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782828/kabod/FB_IMG_1672676579273_e3wt17.jpg",
    },
    {
      id: "eS7",
      name: "KABOD",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782828/kabod/FB_IMG_1672676570215_ia8glb.jpg",
    },
    {
      id: "eS8",
      name: "KABOD",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782829/kabod/FB_IMG_1672676859872_qq7fns.jpg",
    },
    {
      id: "eS9",
      name: "KABOD",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782832/kabod/FB_IMG_1672676898483_nlwn0a.jpg",
    },
  ],
  "KING'S COURT": [
    {
      id: "eE3",
      name: "KING'S COURT",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782721/event1/PXL_6822_arbysj.jpg",
    },
    {
      id: "eE4",
      name: "KING'S COURT",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782721/event1/PXL_6983_sdfxi4.jpg",
    },
    {
      id: "eE5",
      name: "KING'S COURT",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782718/event1/PXL_6797_of7w8c.jpg",
    },
    {
      id: "eE6",
      name: "KING'S COURT",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782718/event1/PXL_6690_osvov0.jpg",
    },
    {
      id: "eE7",
      name: "KING'S COURT",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782718/event1/PXL_6485_upypcv.jpg",
    },
    {
      id: "eE8",
      name: "KING'S COURT",
      pic: "https://res.cloudinary.com/dpi44zxlw/image/upload/v1672782718/event1/PXL_6630_jeofwk.jpg",
    },

  ],
};
